import { render, staticRenderFns } from "./eduIDReports.vue?vue&type=template&id=2238e40c&scoped=true"
import script from "./eduIDReports.vue?vue&type=script&lang=js"
export * from "./eduIDReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2238e40c",
  null
  
)

export default component.exports